/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/BackOffice'

import _ from 'lodash'

import { handleChange } from '@/Form/Functions/eventsHandling'

import Loader from '@Pure/Loader'

import Form        from '@/Form/toolkit/Form'
import FormElement from '@/Form/toolkit/FormElement'

import AbondementAddedHistory from '@/Abondement/AbondementAddedHistory'

const { app, qwest } = window;

export default class AdminAddECAbondementPage extends Component
{
	state =
	{
		form_data:
		{
			added_value: 0
		}
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		component.setState(
		{
			EC_id: id,
			loading: true
		});

		qwest.post('/CMS/get',
		{
			model: 'EnterpriseCommittee',
			id: id
		})
		.then(function (xhr, response)
		{
			if (response.data && response.data.id)
			{
				state.form_data['EC_id'] = response.data.id;
			}

			component.setState(
			{
				loading: false,
				EC: response.data,
				form_data: state.form_data
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false,
				error: error
			});
		})
	}

	handleChange = handleChange.bind(this);

	handleValidate = (response) =>
	{
		const component = this, props = this.props, state = this.state;

		var status_messages = state.status_messages;

		Object.keys(response.fields || { }).forEach(function (field)
		{
			status_messages[field] = response.fields[field];
		});

		if (response.success === true)
		{
			state.form_data['added_value'] = 0;
		}

		state.EC.abondement = state.EC.abondement || { };

		state.EC.abondement.value = response.new_value;

		app.emit('addedECAbondement');

		component.setState(
		{
			status_messages: status_messages,
			form_data: state.form_data,
			error: response.error,
			warning: response.warning,
			info: response.info,
			loading: false,
			EC: state.EC
		});
	}

	handleFailure = (response) =>
	{
		const component = this, props = this.props, state = this.state;

		let status_messages = state.status_messages;

		Object.keys(response.fields || { }).forEach(function (field)
		{
			status_messages[field] = response.fields[field];
		});

		component.setState(
		{
			status_messages: status_messages,
			error: response.error,
			warning: response.warning,
			info: undefined,
			loading: false
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

	/**
	 * Map all status from component.state and return information messages accordingly.
	 *
	 * @param    { Object }    status_data    Infos messages to display.
	 * @param    { String }    index          Iteratof.
	 *
	 * @return    [Array]      Renderable React elements.
	 */
		let status = form_status
		.filter(status_data => typeof state[status_data.label] !== 'undefined')
		.map(function (status_data, index)
		{
			var message =
			(
				<div key={ index } className={ 'c-form-message ' +
					'c-form-message' + status_data.suffix }>
					<div className="c-form-message__content">
						{ state[status_data.label] }
					</div>
				</div>
			);

			return message;
		});

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let submit =
		(
			<div className="c-btn-container c-btn-container--form">
				<button type="submit" className="c-btn c-btn--secondary c-btn--next"
					onClick={ function (e) { e.target.blur(); } }>
					Ajouter { state.form_data.added_value || '0' }&nbsp;€
					{ loader }
				</button>
			</div>
		);

		let title = 'CE introuvable';

		if (state.EC && state.EC.company)
		{
			title = 'Ajouter au CE ' + state.EC.company;
		}

		let current_abondement;

		if (state.EC && state.EC.abondement)
		{
			current_abondement =
			(
				<div className="c-form-message c-form-message--green">
					<div className="c-form-message__content">
						Ce CE possède actuellement un abondement de
						&nbsp;
						<strong>{ state.EC.abondement.value || 0 }&nbsp;€</strong>.
					</div>
				</div>
			);
		}

		let history;

		if (state.EC_id)
		{
			history =
			(
				<div className="u-margin-top-20">
					<AbondementAddedHistory EC_id={ state.EC_id } />
				</div>
			);
		}

		var output =
		(
			<Layout page_title="Ajout d'abondement" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<Form action="/abondement/add" data={ state.form_data }
							hide_button={ true }
							onValidate={ component.handleValidate }
							onError={ component.handleFailure }
							onSubmit={ function ()
							{
								component.setState({ loading: true });
							} }>

							<div className="c-title c-title--form">
								<h2 className="c-title__txt">{ title }</h2>
							</div>

							{ current_abondement }

							<FormElement type="number" name="added_value"
								label="Montant à ajouter" data={ state.form_data }
								onChange={ component.handleChange }
							/>

							{ status }

							{ submit }

							{ loader }
						</Form>

						{ history }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}